/*
  VASILI LIGHTS — DIY pair promo (SHOP-PAIR-001, 2026-10-18).
  1. "Make it a pair" block (snippets/vl-pair-picker.liquid): 2nd-colour swatches,
     ready-made pairs, pair price, one-click add of both kits.
  2. Cart drawer hint (snippets/cart-drawer.liquid): "Add one more kit — it's 50% off"
     while the number of DIY kits in the cart is odd.
  Loaded with defer from both snippets; the guard below keeps it to one run.
  The discount is Shopify's automatic BXGY — nothing here changes prices.
*/
(function () {
  if (window.__vlPair) return;
  window.__vlPair = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var format = (window.theme && theme.moneyFormat) || '€{{amount}}';
    function delimit(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts.join(decimal);
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function track(name, props) {
    try { if (window.rybbit && typeof rybbit.event === 'function') rybbit.event(name, props); } catch (e) {}
  }

  /* ---------- 1. Pair picker ---------- */
  function initPicker(el) {
    var dataEl = el.querySelector('[data-vl-pair-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = el.closest('form');
    if (!form) return;

    var ci = data.colorPos - 1;
    var gi = data.gluePos - 1;
    var byKey = {};
    data.colors.forEach(function (c) { byKey[c.key] = c; });
    var pairs = String(data.pairs || '').split(',').map(function (p) {
      var ks = p.split('+').map(function (s) { return s.trim().toLowerCase(); });
      return ks.length === 2 && byKey[ks[0]] && byKey[ks[1]] ? ks : null;
    }).filter(Boolean);

    var idInput = form.querySelector('[name="id"]');
    var optionSelects = form.querySelectorAll('select[name^="options["]');
    var swatchesEl = el.querySelector('[data-vl-pair-swatches]');
    var readyEl = el.querySelector('[data-vl-pair-ready]');
    var readyList = el.querySelector('[data-vl-pair-ready-list]');
    var nameEl = el.querySelector('[data-vl-pair-second-name]');
    var fullEl = el.querySelector('[data-vl-pair-full]');
    var totalEl = el.querySelector('[data-vl-pair-total]');
    var addBtn = el.querySelector('[data-vl-pair-add]');
    var statusEl = el.querySelector('[data-vl-pair-status]');

    function mainVariant() {
      var id = idInput ? Number(idInput.value) : 0;
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return data.variants[0];
    }
    function keyOf(variant) {
      var name = variant.options[ci];
      for (var i = 0; i < data.colors.length; i++) if (data.colors[i].name === name) return data.colors[i].key;
      return null;
    }
    function secondVariant(key) {
      var main = mainVariant();
      var c = byKey[key];
      if (!c) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (v.options[ci] === c.name && (gi < 0 || v.options[gi] === main.options[gi])) return v;
      }
      return null;
    }

    var mainKey = keyOf(mainVariant());
    var secondKey = null;
    (function defaultSecond() {
      for (var i = 0; i < pairs.length; i++) {
        if (pairs[i][0] === mainKey) { secondKey = pairs[i][1]; return; }
        if (pairs[i][1] === mainKey) { secondKey = pairs[i][0]; return; }
      }
      secondKey = mainKey;
    })();

    data.colors.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vl-pair__swatch';
      b.style.background = c.hex;
      b.title = c.name;
      b.setAttribute('aria-label', c.name);
      b.dataset.key = c.key;
      b.addEventListener('click', function () { secondKey = c.key; render(); });
      swatchesEl.appendChild(b);
    });

    pairs.forEach(function (p) {
      var a = byKey[p[0]], b = byKey[p[1]];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vl-pair__ready-btn';
      btn.dataset.pair = p.join('+');
      btn.innerHTML = '<span class="vl-pair__dots"><span class="vl-pair__dot"></span><span class="vl-pair__dot"></span></span><span></span>';
      var dots = btn.querySelectorAll('.vl-pair__dot');
      dots[0].style.background = a.hex;
      dots[1].style.background = b.hex;
      btn.lastChild.textContent = a.name + ' + ' + b.name;
      btn.addEventListener('click', function () { applyPair(p); });
      readyList.appendChild(btn);
    });
    if (pairs.length) readyEl.hidden = false;

    function applyPair(p) {
      secondKey = p[1];
      if (mainKey !== p[0]) {
        var sel = optionSelects[ci];
        var c = byKey[p[0]];
        if (sel && c) {
          sel.value = c.name;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      setTimeout(sync, 60);
    }

    function render() {
      var main = mainVariant();
      var second = secondVariant(secondKey);
      swatchesEl.querySelectorAll('.vl-pair__swatch').forEach(function (b) {
        var v = secondVariant(b.dataset.key);
        b.disabled = !v || !v.available;
        b.setAttribute('aria-pressed', b.dataset.key === secondKey ? 'true' : 'false');
      });
      readyList.querySelectorAll('.vl-pair__ready-btn').forEach(function (b) {
        var on = b.dataset.pair === mainKey + '+' + secondKey || b.dataset.pair === secondKey + '+' + mainKey;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      nameEl.textContent = byKey[secondKey] ? byKey[secondKey].name : '';
      if (second) {
        var hi = Math.max(main.price, second.price), lo = Math.min(main.price, second.price);
        fullEl.textContent = money(main.price + second.price);
        totalEl.textContent = money(hi + Math.floor(lo / 2));
      }
      var ok = second && main.available && second.available;
      addBtn.disabled = !ok;
      addBtn.textContent = ok ? addBtn.dataset.label : addBtn.dataset.soldOut;
    }

    function sync() {
      mainKey = keyOf(mainVariant());
      render();
    }

    form.addEventListener('change', function () { setTimeout(sync, 60); });
    document.addEventListener('flu:product:variant-change', function () { setTimeout(sync, 0); });

    /*
      The 2nd kit goes in with /cart/add.js; the main kit goes in through the
      theme's own Add to cart button. Only the theme's own add refreshes its
      internal cart state, so the drawer then opens with both kits and the
      discount line. (Adding both by fetch and clicking the cart icon opened
      the drawer with the stale, empty cart - tested 2026-10-18.)
    */
    addBtn.addEventListener('click', function () {
      var main = mainVariant();
      var second = secondVariant(secondKey);
      if (!second) return;
      var nativeAdd = form.querySelector('button[name="add"]');
      var nativeOk = nativeAdd && !nativeAdd.disabled;
      var items = nativeOk
        ? [{ id: second.id, quantity: 1 }]
        : (main.id === second.id
          ? [{ id: main.id, quantity: 2 }]
          : [{ id: main.id, quantity: 1 }, { id: second.id, quantity: 1 }]);
      addBtn.disabled = true;
      statusEl.textContent = '';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          track('pair_add', { product: data.handle, colors: (mainKey || '') + '+' + (secondKey || '') });
          if (nativeOk) {
            nativeAdd.click();
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function (err) {
          statusEl.textContent = (err && (err.description || err.message)) || addBtn.dataset.error;
        })
        .then(function () { setTimeout(render, 300); });
    });

    render();
  }

  /* ---------- 2. Cart drawer hint ---------- */
  var hints = [];
  function updateHints(cart) {
    hints.forEach(function (h) {
      var ids = (h.dataset.kitIds || '').split(',').map(Number);
      var n = 0;
      (cart.items || []).forEach(function (it) { if (ids.indexOf(it.product_id) > -1) n += it.quantity; });
      h.hidden = n % 2 === 0;
    });
  }
  function refreshHints() {
    if (!hints.length) return;
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(updateHints)
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-vl-pair]').forEach(initPicker);
    hints = Array.prototype.slice.call(document.querySelectorAll('[data-vl-pair-hint]'));
    if (!hints.length) return;
    refreshHints();
    document.addEventListener('flu:cart:updated', function (e) {
      if (e.detail && e.detail.cart) updateHints(e.detail.cart); else refreshHints();
    });
    document.addEventListener('flu:cart:item-added', refreshHints);
    document.addEventListener('flu:quick-cart:open', refreshHints);
    var drawer = document.getElementById('cart-flyout-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        if (drawer.classList.contains('is-active')) refreshHints();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
